import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { useAnalytics } from '@Shared/useAnalytics';
import doesPartnerAllowCarvanaFinancing from '@utilities/doesPartnerAllowCarvanaFinancing';
import { selectPartner } from '../../ducks/selectors';
import MenuButton from '../../../Shared/MenuButton';
import MenuDrawerItem from '../../../Shared/MenuDrawerItem';
import MobileDropdownArrow from '../../../Shared/MobileDropdownArrow';

const StyledMenuDrawerItem = styled(MenuDrawerItem)`
  background-color: ${props => props.theme.carvana.gray.background};
  padding: 0 32px;
`;

const InnerDrawerItem = styled.div`
  flex: 1;
  height: ${props => (props.isExpanded ? '460px;' : '60px;')};
  overflow: hidden;
  transition: height 200ms ease-out;
`;

const StyledMenuButton = styled(MenuButton)`
  display: flex;
  flex: 1;
  height: 60px;

  &:hover {
    color: ${props => props.theme.carvana.blue.dark};
    text-decoration: none;
  }
`;

const DropdownWrapper = styled.div`
  margin: -15px 0 37px;
  display: ${props => (props.isExpanded ? 'block' : 'none')};
`;

const DropdownButton = styled(MenuButton)`
  color: ${props => props.theme.carvana.blue.primary};
  display: flex;
  flex: 1;
  font-size: 12px;
  font-weight: 700;
  justify-content: flex-start;
  padding: 16px 0 6px 21px;
  text-decoration: none;
  letter-spacing: 0;
`;

const HowItWorks = ({ partner }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { trackEventAndGo } = useAnalytics();
  const shouldShowFinancingLink = doesPartnerAllowCarvanaFinancing(partner.partnerId);

  const handleExpansionToggle = () => {
    setIsExpanded(prevState => !prevState);
  };

  const handleClickLink = (ev, name) => {
    trackEventAndGo(ev, 'clicked how it works link', {
      platform: 'mobile',
      link: name,
    });
  };

  return (
    <StyledMenuDrawerItem>
      <InnerDrawerItem isExpanded={isExpanded}>
        <StyledMenuButton
          onClick={handleExpansionToggle}
          disableHref
          eventName="user platform - header - expanded how it works"
          eventData={{ platform: 'mobile' }}
        >
          How It Works
          <MobileDropdownArrow isExpanded={isExpanded} />
        </StyledMenuButton>
        <DropdownWrapper isExpanded={isExpanded}>
          <DropdownButton onClick={e => handleClickLink(e, 'Buying From Carvana')} href="/buying-a-car-online-how-it-works" target="_self">
            Buying From Carvana
          </DropdownButton>
          <DropdownButton onClick={e => handleClickLink(e, 'Selling Or Trading In')} href="/selling-or-trades-how-it-works" target="_self">
            Selling Or Trading In
          </DropdownButton>
          {shouldShowFinancingLink && (
            <>
              <DropdownButton onClick={e => handleClickLink(e, 'Finance with Carvana')} href="/learn-financing" target="_self">
                Finance with Carvana
              </DropdownButton>
              <DropdownButton onClick={e => handleClickLink(e, 'Auto Loan Calculator')} href="/auto-loan-calculator" target="_self">
                Auto Loan Calculator
              </DropdownButton>
            </>
          )}
          <DropdownButton onClick={e => handleClickLink(e, 'Carvana Value Tracker')} href="/value-tracker" target="_self">
            Carvana Value Tracker
          </DropdownButton>
          <DropdownButton onClick={e => handleClickLink(e, 'Our Protection Plans')} href="/vehicle-protection-plans" target="_self">
            Our Protection Plans
          </DropdownButton>
          <DropdownButton onClick={e => handleClickLink(e, 'Repairs with Carvana')} href="/repairs" target="_self">
            Repairs with Carvana
          </DropdownButton>
          <DropdownButton onClick={e => handleClickLink(e, 'Certified Cars')} href="/certified-program" target="_self">
            Certified Cars
          </DropdownButton>
          <DropdownButton onClick={e => handleClickLink(e, 'Carvana Insurance')} href="/insurance" target="_self">
            Carvana Insurance
          </DropdownButton>
          <DropdownButton onClick={e => handleClickLink(e, 'Used EV Tax Credit')} href="/used-ev-tax-credit" target="_self">
            Used EV Tax Credit
          </DropdownButton>
        </DropdownWrapper>
      </InnerDrawerItem>
    </StyledMenuDrawerItem>
  );
};

const mapStateToProps = state => {
  return {
    partner: selectPartner(state),
  };
};

HowItWorks.propTypes = {
  partner: PropTypes.shape({
    partnerId: PropTypes.string
  }),
};

export default connect(mapStateToProps)(HowItWorks);
